// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { DeleteConfirmModal, Table } from ".";
import {

  GridColDef,
  GridPaginationModel,
} from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  useAddTerminal,
  useAuthorization,
  useDocumentDelete,
  useGetTerminalList,
} from "../../hooks";
import { useSetSnackBar } from "../../store/Snackbar.state";
import { default as dayjs } from "dayjs";
import { downloadExcel } from "../../util/downloadExcel";
import { Button, Loading } from "../atoms";


export function TerminalDetailModal({ isOpen, handleClose, merchantId }) {
  const { showDelete, showUpdate } = useAuthorization();
  const theme = useTheme();
  const setSnackbar = useSetSnackBar();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [tableData, setTableData] = useState([]);
  const { mutate: getTerminalList } = useGetTerminalList();
  const { mutate: addTerminal, isLoading: isAddingIks } = useAddTerminal();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const { mutate: deleteDocument, isLoading: isDeleteLoading } =
    useDocumentDelete();

  const deleteRow = (id: number) => {
    setIsDeleteModalOpen(true);
    setSelectedRowId(id);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteTerminalListtRequest = { id: selectedRowId };

    deleteDocument(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          // Silme işlemi başarılı olduğunda tekrar liste çekilir.
          getTerminalList(
            { merchantId: merchantId },
            {
              onSuccess: (data) => {
                if (data.isSuccess) {
                  setTableData(data.data);
                  setSnackbar({
                    severity: "success",
                    isOpen: true,
                    description: data.message,
                  });
                } else {
                  setSnackbar({
                    severity: "error",
                    description: data.message,
                    isOpen: true,
                  });
                }
              },
              onError: () => {
                setSnackbar({
                  severity: "error",
                  description: "Liste çekilirken bir hata oluştu",
                  isOpen: true,
                });
              },
            }
          );

          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    const req: GetTerminalListRequest = {};

    getTerminalList(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const TerminalAddButton = ({ merchantId,terminalId,addTerminal,disabled }) => {
    const handleTerminalAdd = () => {
        addTerminal(
            { merchantId: merchantId,terminalId:terminalId },
            {
                onSuccess: (data) => {
                    if (data.isSuccess) {
                        setSnackbar({
                            severity: 'success',
                            description: data.message ||'İşlem başarılı.',
                            isOpen: true,
                        });
                        setShouldRefresh(prev => !prev);
                    } else {
                        setSnackbar({
                            severity: 'error',
                            description: data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: 'error',
                        description: 'İşlem sırasında bir hata oluştu.',
                        isOpen: true,
                    });
                },
            }
        );
    };

    return (
        <Button 
        text="IKS ye Ekle"
            variant="text" 
            color="info"
            disabled={disabled}
            sx={{ flex: 1, height: 20, py: 5 }}
            onClick={handleTerminalAdd}>
            
         
        </Button>
    );
};

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "terminalAddButton",
        headerName: "IKS ye Ekle",
        width: 150,
        renderCell: (params) => {
          const isDisabled = params.row.iksIsSuccess === true;
            return <TerminalAddButton merchantId={params.row.merchantId} terminalId={params.row.terminalId} addTerminal={addTerminal} disabled={isDisabled} />;
        },
    },
      { field: 'bankCode', headerName: 'Banka Kodu', width: 120 },
      { field: 'bankName', headerName: 'Banka Adı', width: 250 },
      { field: 'bankMerchantId', headerName: 'Banka Üye İşyeri ID', width: 180 },
      { field: 'terminalId', headerName: 'Terminal ID', width: 150 },
      {
        field: 'iksIsSuccess',
        headerName: "IKS'ye Eklendi mi?",
        width: 150,
        renderCell: (params) => {
          return params.value ? 'Evet' : 'Hayır';
        }
      },
    ];
  }, [deleteRow, showDelete]);

  useEffect(() => {
    if (isOpen && merchantId) {
      getTerminalList(
        { merchantId: merchantId },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setTableData(data.data);
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    }
  }, [isOpen, merchantId, shouldRefresh]);

  const onSave = () => {
    getTerminalList(
      { merchantId: merchantId },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Banka Kodu": item?.bankCode,
                  "Banka Adı": item?.bankName,
                  "Banka Üye İşyeri ID": item?.bankMerchantId,
                  "Terminal ID": item?.terminalId,
                  "IKS?'ye Eklendi mi?": item?.iksIsSucces ? 'Evet' : 'Hayır'
                };
              });
            }
            const refactoredData = fieldValue(data?.data);
            downloadExcel(refactoredData || [], "Terminal Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          console.log(error);
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isDesktop ? 1300 : isSmallScreen ? "90%" : "70%",
          maxHeight: '90vh',  // eklenen satır
          maxWidth: '90vw',  // eklenen satır
          overflow: 'auto',  // eklenen satır
          bgcolor: "background.paper",
          border: "2px solid #2196f3",
          boxShadow: 24,
          p: 4,
          display: "relative",
        }}
      >
        <h2 id="modal-modal-title">Terminal Listesi</h2>

        <Stack
          justifyContent="center"
          sx={{ width: 1, height: "90%", flexGrow: 1 , overflowX: 'auto',}}
        >
          {tableData && (
            <>
            {isAddingIks && <Loading/>}
            
                <Table
                 columnVisibilityConfigKey="terminalDetailModalColumnVisibilityKey"
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  className="myTable"
                  rowCount={tableData.totalItems}
                  sx={{
                    width: isDesktop ? 1240 : "auto",
                    height: isDesktop ? "600px" : "auto",
                  }}
                  isRowSelectable={() => false}
                  disableColumnMenu
                  rows={tableData}
                  // hideFooterPagination
                  autoHeight={!isDesktop}
                  columns={columns}
                  exportFileName="Terminal"
                  customLabelDisplayedRows={true}
                  onSave={() => onSave()}
                />
             
              <DeleteConfirmModal
                isOpen={isDeleteModalOpen}
                onClose={handleCloseDeleteModal}
                onConfirm={() => handleDeleteConfirm()}
              ></DeleteConfirmModal>
            </>
          )}
        </Stack>
        {/* <Button onClick={handleClose}>Close</Button> */}
        <IconButton
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
}
